
import React from 'react';
import { Link, useLocation } from 'react-router';
import { cn } from '@/lib/utils';

interface NavLinkProps {
  to: string;
  icon: React.ReactNode;
  children?: React.ReactNode;
  className?: string;
  tooltip?: string;
  onClick?: () => void;
}

export const NavLink: React.FC<NavLinkProps> = ({
  to,
  icon,
  children,
  className,
  tooltip,
  onClick,
}) => {
  const location = useLocation();
  const isActive = location.pathname === to;

  return (
    <Link
      to={to}
      onClick={onClick}
      className={cn(
        'flex items-center gap-3 px-3 py-2 rounded-lg text-sm font-medium transition-all duration-200',
        'hover:bg-accent hover:text-accent-foreground',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
        'active:scale-[0.98]',
        isActive && 'bg-accent text-accent-foreground',
        className
      )}
      title={tooltip}
    >
      <span className="flex-shrink-0">{icon}</span>
      {children}
    </Link>
  );
};
